import { useUserRole } from '../context/userroleContext';

const useRole = () => {
    const { user, hasAccess, hasOptionAccess, getTaskMenuOptions, permissions } = useUserRole();

    return {
        hasAccess,
        hasOptionAccess,
        getTaskMenuOptions,
        canEdit: (task) => hasAccess(task, table, true),
        canEditOption: (parentTask, option) => hasOptionAccess(parentTask, option, table, true),
        isAdmin: !!(permissions.admin?.find(t => t.task === 'Admin')?.accessLevel === 'CRUD'),
        isHR: !!(permissions.hr?.length),
        isSS: !!(permissions.ss?.length),
    };
};

export default useRole;